<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> </template>

    <div class="container-fluid" style="text-align: left">
      <div class="row mt-3">
        <div class="col-sm-3">
          <admin-nav></admin-nav>
        </div>

        <div class="col-sm-9">
          <div class="d-flex flex-row align-items-start">
            <div class="row flex mr-3">
              <div
                class="col-12 col-lg-4 mb-2 d-flex flex-row align-items-center"
              >
                <i
                  v-if="!filter"
                  style="min-width: 15px"
                  class="fas fa-search mx-2"
                />
                <i
                  v-if="filter"
                  style="min-width: 15px; padding-left: 2px; padding-top: 2px"
                  class="fas fa-times mx-2 clickable"
                  @click="filter = ''"
                />
                <input
                  v-if="!selectedDistrict"
                  class="form-control listing-search"
                  placeholder="Search districts..."
                  v-model="filter"
                />
                <input
                  v-if="selectedDistrict"
                  class="form-control listing-search"
                  placeholder="Search classes..."
                  v-model="filter"
                />
              </div>
            </div>
            <button
              v-if="selectedDistrict"
              @click="selectedDistrict = null"
              class="btn btn-primary mr-3"
            >
              Back
            </button>
            <button
              @click="exportItems"
              class="btn btn-primary mr-3"
              v-tippy
              title="Export"
            >
              <i class="fas fa-file-export" />
            </button>
            <a href="/#/districts/new" class="btn btn-primary mr-3">New</a>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              style="float: right"
            ></b-pagination>
          </div>
          <b-table
            ref="table"
            :show-empty="true"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :key="selectedDistrict"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(profiles)="data">
              {{ count("profiles", data.item.id) }}
            </template>
            <template v-slot:cell(pitches)="data">
              {{ count("pitches", data.item.id) }}
            </template>
            <template v-slot:cell(tvr_feedbacks)="data">
              {{ count("tvrs", data.item.id) }}
            </template>
            <template v-slot:cell(canvases)="data">
              {{ count("canvases", data.item.id) }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import AdminService from "@/services/AdminService";
import FileService from "@/services/FileService";
import Notie from "@/services/NotieService";
import _ from "lodash";

export default {
  name: "AdminLanding",

  props: ["user"],

  components: { MainPage, AdminNav },

  data() {
    return {
      service: AdminService,

      filter: null,
      currentPage: 1,
      perPage: 25,
      sortBy: "",
      sortDesc: false,
      totalRows: 1,

      profiles: [],
      pitches: [],
      tvrs: [],
      canvases: [],

      selectedDistrict: null,
      count_data: null,

      fields: [
        { key: "name", label: "District", sortable: true },
        { key: "profiles", label: "Profiles", sortable: true },
        { key: "pitches", label: "Pitches", sortable: true },
        { key: "tvr_feedbacks", label: "TVRs", sortable: true },
        { key: "canvases", label: "Canvases", sortable: true },
      ],
    };
  },

  watch: {
    selectedDistrict() {
      this.filter = "";
      if (this.selectedDistrict) {
        this.fields[0].label = "Section";
      } else {
        this.fields[0].label = "District";
      }
    },
  },

  methods: {
    count(key, id) {
      console.log(this.count_data[key]);
      console.log(id);
      var item = _.find(this.count_data[key], (item) => {
        return item._id == id;
      });
      if (item && item.count) {
        return item.count;
      } else {
        return 0;
      }
    },

    items() {
      var pageOpts = {
        filter: this.filter,
        query: {},
        page_size: this.perPage,
        current_page: this.currentPage,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        skip: (this.currentPage - 1) * this.perPage,
      };

      let timestamp = new Date().getTime();
      this.latest = timestamp;

      if (this.selectedDistrict) {
        pageOpts.query["district_id"] = this.selectedDistrict.id;
        console.log(pageOpts);
        return new Promise((resolve, reject) => {
          this.service
            .listSections(pageOpts)
            .then((resp) => {
              if (timestamp != this.latest) {
                return;
              }

              console.log(resp);
              resolve(resp.data.result);
              this.totalRows = resp.data.count;

              this.service
                .getSectionCounts(this.selectedDistrict.id)
                .then((resp) => {
                  console.log(resp.data);
                  this.count_data = resp.data;
                })
                .catch((e) => {
                  console.log(e);
                });
            })
            .catch((e) => {
              reject(e);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.service
            .listDistricts(pageOpts)
            .then((resp) => {
              if (timestamp != this.latest) {
                return;
              }

              console.log(resp);
              resolve(resp.data.result);
              this.totalRows = resp.data.count;

              this.service
                .getDistrictCounts()
                .then((resp) => {
                  console.log(resp.data);
                  this.count_data = resp.data;
                })
                .catch((e) => {
                  console.log(e);
                });
            })
            .catch((e) => {
              reject(e);
            });
        });
      }
    },

    rowClicked(record) {
      if (!this.selectedDistrict) {
        this.selectedDistrict = record;
      }
    },

    exportItems() {
      var pageOpts = {
        filter: this.filter,
        query: {},
        page_size: this.perPage,
        current_page: this.currentPage,
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        skip: (this.currentPage - 1) * this.perPage,
      };

      if (this.selectedDistrict) {
        pageOpts.query["district_id"] = this.selectedDistrict.id;
        this.service
          .listSections(pageOpts)
          .then((resp) => {
            this.service
              .getSectionCounts(this.selectedDistrict.id)
              .then((r) => {
                FileService.exportActivity(resp.data.result, "District", r.data);
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
            Notie.error("Failed to export data", e);
          });
      } else {
        this.service
          .listDistricts(pageOpts)
          .then((resp) => {
            this.service
              .getDistrictCounts()
              .then((r) => {
                FileService.exportActivity(resp.data.result, "Section", r.data);
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log(e);
            Notie.error("Failed to export data", e);
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.join-code {
  font-size: 32px;
  text-align: center;
}
</style>